"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntentionCommitRequest = void 0;
var IntentionCommitRequest = /** @class */ (function () {
    function IntentionCommitRequest() {
    }
    return IntentionCommitRequest;
}());
exports.IntentionCommitRequest = IntentionCommitRequest;
;
//# sourceMappingURL=intentionCommit.request.js.map